export const CHANGE_TERM = 'CHANGE_TERM'
export const CLEAR_TERM = 'CLEAR_TERM'
export const CHANGE_FILTER = 'CHANGE_FILTER'
export const CLEAR_FILTER = 'CLEAR_FILTER'

export const changeFilter = filter => dispatch => dispatch({ type: CHANGE_FILTER, filter })

export const clearFilter = () => dispatch => dispatch({ type: CLEAR_FILTER })

export const changeTerm = term => {
  return dispatch => {
    dispatch({ type: CHANGE_TERM, term })
  }
}

export const clearTerm = () => {
  return dispatch => {
    dispatch({ type: CLEAR_TERM })
  }
}



// WEBPACK FOOTER //
// ./src/actions/searchTable.js